import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import {
  CLIENT_SSO_ENTRY_PATH,
  isClientSsoUser,
} from "../../constants/clientSso";

const ClientOnlyRoute = ({ children }: { children: React.ReactElement }) => {
  const user = useSelector((state: RootState) => state.user.userInfo);

  if (!user) {
    return <Navigate to={CLIENT_SSO_ENTRY_PATH} replace />;
  }

  if (!isClientSsoUser(user.group)) {
    return <Navigate to="/designer-page" replace />;
  }

  return children;
};

export default ClientOnlyRoute;
